module.exports = __webpack_public_path__ + "img/prize-icon.a5f2414e.svg";